// extracted by mini-css-extract-plugin
export default {"container":"V7JxFl","circle1":"hEgvYX","circle2":"_2-o58I"};